import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import { Box, Paper } from '@material-ui/core';
import StepConnector from '@material-ui/core/StepConnector';
import dottedLineGray from '../../../../assets/dottedLineGray.svg';

const CustomPaper = withStyles({
    root: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
    },
})(Paper);

const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 19,
        paddingLeft: '10px',
        paddingRight: '10px',
        borderRadius: '50%',
    },
    active: {
        '& $line': {
            background: '#3399DB',
        },
    },
    completed: {
        '& $line': {
            background: '#3399DB',
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: 'none',
        backgroundImage: `url(${dottedLineGray})`,
        borderRadius: 1,
    },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#3399DB',
        border: '3px solid #3399DB',
        zIndex: 1,
        color: '#fff',
        width: 38,
        height: 38,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        opacity: 0.2,
    },
    active: {
        background: '#3399DB',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        opacity: 1,
    },
    completed: {
        background: '#3399DB',
        opacity: 1,
    },
    error: {
        border: 'none',
        background: 'none',
        opacity: 1,
        boxShadow: 'none',
        width: '60px',
    },
    errorWithoutIcon: {
        background: '#EB4C37',
        border: '3px solid #EB4C37',
    },
});

function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed, error, icon } = props;

    return (
        <Box
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
                [classes.errorWithoutIcon]: error,
            })}
        >
            {icon}
        </Box>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
    icon: PropTypes.node,
};

type Steps = string[];

type Props = {
    steps: Steps;
    activeStep: number;
    setActiveStep: (step: number) => void;
    stepFailed?: number;
    displayLabel?: boolean;
};

const useStyles = makeStyles((theme) => ({
    root: {},
    customLabel: {
        color: '#2574A9',
        fontSize: '1rem',
        fontFamily: 'Open Sans',
        fontWeight: 700,
        textTransform: 'uppercase',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            fontSize: '0.8rem',
            fontWeight: 500,
            display: 'block',
        },
    },
    customLabelNotCompleted: {
        color: '#2574A9',
        fontSize: '1rem',
        fontFamily: 'Open Sans',
        fontWeight: 700,
        textTransform: 'uppercase',
        opacity: 0.2,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            fontSize: '0.8rem',
            fontWeight: 500,
            display: 'block',
        },
    },
    errorLabel: {
        color: '#EB4C37',
        fontSize: '1rem',
        fontFamily: 'Open Sans',
        fontWeight: 700,
        textTransform: 'uppercase',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            fontSize: '0.8rem',
            fontWeight: 500,
            display: 'block',
        },
    },
    clickableStep: {
        cursor: 'pointer',
    },
}));

const SGSMuiStepperDotted: React.FC<Props> = ({ steps, activeStep, setActiveStep, stepFailed, displayLabel = false }) => {
    const classes = useStyles();

    const isStepFailed = (step) => {
        return step === stepFailed;
    };

    const handleStepClick = (index) => {
        // TODO :: reactivate to control navigation
        //if (index < activeStep || index === activeStep) {
        setActiveStep(index);
        //}
    };

    return (
        <Box className={classes.root}>
            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />} component={CustomPaper}>
                {steps.map((label, index) => {
                    const labelProps: any = {};
                    if (isStepFailed(index)) {
                        labelProps.error = true;
                    }
                    const isClickable = index < activeStep || index === activeStep;
                    return (
                        <Step key={label} onClick={() => handleStepClick(index)} className={isClickable ? classes.clickableStep : ''}>
                            <StepLabel {...labelProps} StepIconComponent={ColorlibStepIcon}>
                                <Box className={index < activeStep || activeStep === index ? (labelProps.error ? classes.errorLabel : classes.customLabel) : classes.customLabelNotCompleted}>
                                    {displayLabel && label}
                                </Box>
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    );
};

export default SGSMuiStepperDotted;
